import { render, staticRenderFns } from "./TelemedecineSansRV.vue?vue&type=template&id=52d9db0f&"
import script from "./TelemedecineSansRV.vue?vue&type=script&lang=js&"
export * from "./TelemedecineSansRV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports